// REAL PHOTOS from Craig's jobs — all three jobs are true before/after pairs.
const ASSETS =
  "https://customer-assets-agu9un31.emergentagent.net/job_after-paint-pro/artifacts";

export const GALLERY_JOBS = [
  {
    title: "Weatherboard Rescue",
    location: "Yamba",
    scope: "Rotten board repair, full prep & repaint",
    before: `${ASSETS}/5del8b7l_before%20rotten.jpg`,
    after: `${ASSETS}/6tf6d58w_After%20rotten.jpg`,
    beforeFilter: "none",
    afterFilter: "none",
    testid: "gallery-job-weatherboard",
  },
  {
    title: "Brick to Brilliant",
    location: "Yamba",
    scope: "Full brick exterior repaint — clean, prime, two topcoats",
    before: `${ASSETS}/4wbalkpu_before%20brick.jpg`,
    after: `${ASSETS}/9wvtppac_after%20brick.jpg`,
    beforeFilter: "none",
    afterFilter: "none",
    testid: "gallery-job-brick",
  },
  {
    title: "Shade & Trim Transformation",
    location: "Clarence Valley",
    scope: "Weatherboard, awnings & trim — full colour refresh",
    before: `${ASSETS}/jgeblcyr_before%20shade.jpg`,
    after: `${ASSETS}/k79lx8e8_after%20shade.jpg`,
    beforeFilter: "none",
    afterFilter: "none",
    testid: "gallery-job-shade",
  },
];
